import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 26,
    position: 'absolute',
    bottom: 75,
    left: (useStylesParams) => useStylesParams.space - 5,
    backgroundColor: '#fff',
    boxShadow: theme.shadows[12],
    borderRadius: theme.shape.borderRadius,
    width: 225,
  },
  reasons: {
    zIndex: 27,
    position: 'absolute',
    bottom: 135,
    left: 220,
    backgroundColor: '#fff',
    boxShadow: theme.shadows[12],
    borderRadius: theme.shape.borderRadius,
    width: 350,
  },
  reasonsHeader: {
    padding: 15,
  },
  reasonsSearch: {
    padding: 15,
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  reasonsContent: {
    overflowY: 'auto',
    maxHeight: 200,
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  listItem: {
    '&:hover': {
      backgroundColor: (useStylesParams) =>
        useStylesParams.active
          ? theme.palette.primary.secondary
          : theme.palette.divider,
    },
  },
}))

export default useStyles
